import React, { Component } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

class SkillCard extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    AOS.init({ duration: 2000 });
  }
  render() {
    const { col } = this.props;
    console.log(col);
    return (
      <div
        className="Skill"
        style={{ backgroundColor: `${col}` }}
        data-aos="fade-right"
        data-aos-anchor=".education-section"
        data-aos-anchor-placement="bottom-center"
        data-aos-duration="1000"
      >
        <div className="skillname">{this.props.name}</div>
        <div className="skill-img">
          <img src={this.props.img}></img>
        </div>
        <div
          className="progress-bar"
          style={{ backgroundColor: "white", borderRadius: "50%" }}
        >
          <CircularProgressbar
            styles={{ backgroundColor: "white" }}
            value={this.props.percent}
            text={`${this.props.percent}%`}
          />
        </div>
      </div>
    );
  }
}

export default SkillCard;
